import React from "react";

//---------------------------------------------------------------------------
// MUI Components
//---------------------------------------------------------------------------
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

function PageLoading({
  // Props
  size = 150,
}) {
  //---------------------------------------------------------------------------
  // Render
  //---------------------------------------------------------------------------
  return (
    <Grid container>
      <Grid sx={{ mt: 10 }} align="center" size={12}>
        <CircularProgress size={size} data-cy="page-loading" />
      </Grid>
    </Grid>
  );
}

export default PageLoading;
